import { Heading, useIsMobile } from '@grupoboticario/flora-react'
import { ArrowRightIcon } from '@grupoboticario/flora-react-icons'
import { useCart, useReseller } from 'src/hooks'

import { useCartMenu, useFeatureFlag } from '@grupoboticario/barril-del-chavo'
import * as Styled from './CheckoutCTA.styles'

const EXPERIMENT_SIDE_CART_FLAG_KEY = 'experiment_side_cart'

export const CheckoutCTA = () => {
  const { data: reseller } = useReseller()
  const isMobile = useIsMobile()
  const cart = useCart()
  const { openBag } = useCartMenu()
  const [hasSideCart] = useFeatureFlag(EXPERIMENT_SIDE_CART_FLAG_KEY)

  const hasItemsInCart = cart.totalCartItems > 0

  const showCallToAction = isMobile && hasItemsInCart

  const text = 'Finalizar compra'

  const handleClick = () => {
    if (hasSideCart) {
      openBag()
      return
    }

    window.location.href = `/${reseller?.catalogSlug}/carrinho`
  }

  if (!showCallToAction) {
    return null
  }

  return (
    <div style={{ height: 66, position: 'relative' }}>
      <Styled.Wrapper id="call-to-action-checkout">
        <Styled.Button
          autotagging-flora="on"
          data-flora-text={text}
          onClick={handleClick}
          variant="unstyled"
          rightIcon={<ArrowRightIcon color="$nonInteractiveAltPredominant" />}
        >
          <Heading
            level="6"
            color="$nonInteractiveAltPredominant"
          >
            {text}
          </Heading>
        </Styled.Button>
      </Styled.Wrapper>
    </div>
  )
}
